import { Component, OnInit } from '@angular/core';

import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ProcedimentoService } from './procedimento.service';
import { Procedimento } from '../shared/model/procedimento.model';
import { Pageable } from '../shared/model/pageable.model';
import { ToastrService } from 'ngx-toastr';

@Component({
    templateUrl: './procedimento.component.html',
    styleUrls: ['./procedimento.component.css']
})
export class ProcedimentoComponent implements OnInit {

  procedimento: Procedimento;
  valueFilter = '';
  pageable: Pageable;
  listaProcedimentos: Procedimento[];

  labels: any = { previousLabel: '', nextLabel: '' };

  constructor(config: NgbModalConfig, private modalService: NgbModal, private procedimentoService: ProcedimentoService,
      private toast: ToastrService) {
       // customizar os valores default do modal.
        config.backdrop = 'static';
        config.keyboard = false;
   }

  ngOnInit() {
    // Inicializando o pageable com valores padrões.
    this.pageable = new Pageable();
    this.getProcedimentos();
  }

  pageChanged(event) {
    this.pageable.page = event;
    this.getProcedimentos();
  }

  buscarProcedimentos() {
    this.pageable.page = 1;
    this.getProcedimentos();
  }

  private getProcedimentos() {
    this.procedimentoService.listarProcedimentos(this.pageable, this.valueFilter).subscribe(
      (dados) =>  {
        this.pageable.totalElements = dados.totalElements;
        this.listaProcedimentos = dados.content;
      },
      errorResponse => this.toast.error(errorResponse.error.mensagemUsuario)
    );
  }

  // Método responsável por preparar o modal para cadastrar um novo procedimento
  novoProcedimento(content) {
      // Inicializar o objeto toda vez que o modal for chamado
      this.procedimento = new Procedimento();

      // Abrir o modal
      this.modalService.open(content, { size: 'lg' });
  }

  // Método responsável para preparar o modal para alteração
  alterarProcedimento(content, procedimentoId: number) {
    this.procedimentoService.buscar(procedimentoId).subscribe(
        (procedimento) => {
          this.procedimento = procedimento;

          // Abrir o modal com os dados do procedimento
          this.modalService.open(content, { size: 'lg' });
        },
        (errror) => this.toast.error('Erro ao carregar procedimento, tente novamente!')
    );
  }

  // Método usado para cadastrar/alterar um procedimento
  save(form) {

    if (this.procedimento.id) {
        this.procedimentoService.alterar(this.procedimento).subscribe(
          () => {
            this.toast.success('Procedimento alterado com sucesso!');

            this.getProcedimentos();
          },
          (responseError) => this.toast.error('Erro ao alterar o procedimento, tente novamente!')
        );
    } else {
      this.procedimentoService.cadastrar(this.procedimento).subscribe(
        () => {
          this.toast.success('Procedimento cadastrado com sucesso!');

          this.pageable.page = 1;
          this.getProcedimentos();

          // Resetar o form após confirmar
          form.reset();

          // Inicializar o objeto toda vez que for alterado.
          this.procedimento = new Procedimento();
        },
        (responseError) => this.toast.error('Erro ao cadastrar o procedimento, tente novamente!')
      );
    }
  }

  inativarProcedimento(procedimentoId: number) {
    this.procedimentoService.inativar(procedimentoId).subscribe(
      () => {
        this.toast.success('Procedimento inativado com sucesso!');
        this.getProcedimentos();
      },
      (responseError) => this.toast.error('Erro ao inativar procedimento, tente novamente!')
    );
  }

  ativarProcedimento(procedimentoId: number) {
    this.procedimentoService.ativar(procedimentoId).subscribe(
      () => {
        this.toast.success('Procedimento ativado com sucesso!');
        this.getProcedimentos();
      },
      (responseError) => this.toast.error('Erro ao ativar procedimento, tente novamente!')
    );
  }
}
